(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // When a swatch/variant is selected on the collection card,
  // update the card's <a> link so clicking goes to that variant on the product page.
  document.addEventListener('change', function (e) {
    const input = e.target;

    // Only handle variant option inputs inside a product-card
    if (!input.matches('product-card input[type="radio"], product-card select')) return;

    const card = input.closest('product-card');
    if (!card) return;

    const productId = card.dataset.productId;
    const productLink = card.querySelector('.product-card__link');
    if (!productLink || !productId) return;

    // Collect all currently selected option values for this card
    const allInputs = card.querySelectorAll('input[type="radio"]:checked, select');
    const selectedOptions = {};

    allInputs.forEach(function (inp) {
      const name = inp.name || inp.dataset.optionName;
      if (name) selectedOptions[name] = inp.value;
    });

    // Find matching variant via Shopify product JSON
    const productHandle = productLink.href.split('/products/')[1]?.split('?')[0]?.split('#')[0];
    if (!productHandle) return;

    fetch('/products/' + productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        const selectedValues = Object.values(selectedOptions);

        const matched = product.variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return selectedValues.length === 0 || selectedValues.includes(opt);
          }) && variant.options.every(function (opt) {
            return selectedValues.includes(opt);
          });
        });

        if (matched) {
          // Build new URL with variant id
          const baseUrl = '/products/' + productHandle;
          productLink.href = baseUrl + '?variant=' + matched.id;

          // Also update the product-card-link wrapper if present
          const cardLinkWrapper = card.closest('product-card-link');
          if (cardLinkWrapper) {
            const allAnchors = cardLinkWrapper.querySelectorAll('a.product-card__link');
            allAnchors.forEach(function (a) {
              a.href = baseUrl + '?variant=' + matched.id;
            });
          }
        }
      })
      .catch(function () {});
  });
  } catch(e) { console.error(e); }
})();

})();
